// NOTE: keep in sync with each app's public/assets/i18n/*.json.
export const LocaleKey = {
  EN_US: 'en-US',
  FR_FR: 'fr-FR',
};

export const defaultLocale = LocaleKey.EN_US;

export const availableLocales = Object.values(LocaleKey);
